import { useDashboard } from "@platform/features/dashboard/DashboardContext";
import { TalkJSData } from "../chat.types";
import {
  useChat,
  useChatDispatch,
  OPEN_CHAT,
  CLOSE_CHAT,
  TOGGLE_CHAT,
} from "../ChatContext";

export function useTalkJSData(): TalkJSData | null {
  const dashboard = useDashboard();

  // dashboard is expected to have a talkjs property with app_id, token, conversations
  return dashboard?.talkjs || null;
}

export function useChatActions() {
  const dispatch = useChatDispatch();
  const talkjsData = useTalkJSData();

  const openChat = () => {
    if (talkjsData) {
      dispatch({ type: OPEN_CHAT });
    }
    // Optionally, you could show a toast or feedback if talkjsData is missing
  };
  const closeChat = () => dispatch({ type: CLOSE_CHAT });
  const toggleChat = () => dispatch({ type: TOGGLE_CHAT });

  return {
    openChat,
    closeChat,
    toggleChat,
  };
}

export { useChat };
